import React, { useState } from 'react'

export const SectionCard = ({ id, title, description, count, actions, toolbar, collapsible, busy, children }) => {
    const [expanded, setExpanded] = useState(true)
    const bodyId = `${id}-body`

    return (
        <section className={`card rt-card${expanded ? '' : ' rt-card-collapsed'}`} aria-labelledby={`${id}-title`} aria-busy={busy || undefined}>
            <div className="card-body">
                <div className="rt-card-header">
                    <div className="rt-card-heading">
                        <h2 id={`${id}-title`} className="rt-card-title">
                            {collapsible
                                ? (
                                    <button
                                        type="button"
                                        className="rt-card-toggle"
                                        aria-expanded={expanded}
                                        aria-controls={bodyId}
                                        onClick={() => setExpanded(!expanded)}
                                    >
                                        <i className={`fas fa-chevron-${expanded ? 'down' : 'right'} rt-card-chevron`} aria-hidden="true" />
                                        {title}
                                    </button>
                                )
                                : title
                            }
                        </h2>
                        {description && <p className="rt-card-description">{description}</p>}
                    </div>
                    {(count || (expanded && actions)) &&
                        <div className="rt-card-meta">
                            {count && <span className="rt-count-pill">{count}</span>}
                            {expanded && actions}
                        </div>
                    }
                </div>
                <div id={bodyId} hidden={!expanded}>
                    {toolbar && <div className="rt-card-toolbar">{toolbar}</div>}
                    {children}
                </div>
            </div>
        </section>
    )
}
